/**
 * Classes for a link that sits inside a sentence or paragraph of running text.
 * Colour alone (text-brand vs the surrounding muted/ink text) isn't reliable
 * contrast for distinguishing a link — axe's link-in-text-block flags this in
 * dark mode. Keep the underline on permanently instead of only on hover.
 *
 * Standalone links (nav items, footer link lists, button-like links on their
 * own line) aren't "in text" and can keep the hover-only underline instead.
 */
export const inlineLinkClass = 'text-brand underline underline-offset-4 decoration-brand/40 hover:decoration-brand';
